import { FormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ProfileService } from './../profile.service';
import { AuthService } from './../../auth/auth.service';
import { CustomerEnrollService } from '../../customer-enroll/customer-enroll.service';
import { Router, ActivatedRoute, Params, NavigationEnd } from '@angular/router';
import { Component, OnInit, Inject, OnChanges, SimpleChanges, Input } from '@angular/core';
import { SharedService } from '../../shared/shared.service';
import { LocalStorageService } from 'angular-2-local-storage';
import { LoggerService } from '../../logger/logger.service';

const MOBILE_REGEX = /^\(\d{3}\)\s\d{3}\-\d{4}$|^\d{10}$/;
const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

@Component({
  selector: 'app-contact-info',
  templateUrl: './contact-info.component.html',
  styleUrls: ['./contact-info.component.css']
})
export class ContactInfoComponent implements OnInit, OnChanges {
  private token: string;
  private person: any;
  private service_address: Object;
  private user_id: string;
  public firstName: string;
  public lastName: string;
  public email: string;
  public mobile_no: string;
  public initialEmail: string;
  public initialMobile: string;

  public hasEmail: boolean;
  public dropDisable: boolean;
  public hasMobile: boolean;
  public mobileFormatError: boolean;
  public isEmailError: boolean = false;
  public isMobileError: boolean = false;
  public isContactMethodChanged: boolean;
  public isEmailVerified: boolean;
  public isMobileVerified: boolean;
  private isEmailAddUpdate: boolean;
  private isMobileAddUpdate: boolean;
  public is_loader: boolean;
  public is_acc_setting: boolean = false;
  public is_contact_method_changed: boolean = false;
  public dropDisabled: boolean = false;
  public emailError = "";
  public mobileError = "";
  public mobileChanged: boolean = false;
  public emailChanged: boolean = false;
  public mobileFirstLoad: boolean = true;
  public emailFirstLoad: boolean = true;
  public mySubscription: any;
  public saveText = 'Save';

  public email_verified = false;
  public email_verification_required = false;
  public isWaitingEmailVerification = false;
  public isSavingEmail = false;
  public emailSaveText = 'Save';
  public emailVerifyText = 'Verify';

  public preferred_contact_method;
  public is_valid_number:boolean;
  methods = [];

  mobilePhoneFormControl = new FormControl('', [
    Validators.pattern(MOBILE_REGEX)
  ]);
  emailFormControl = new FormControl('', [
    Validators.pattern(EMAIL_REGEX)
  ]);

  public phoneMask = ['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

  constructor(private sharedService: SharedService, private localStorageService: LocalStorageService, private authService: AuthService, 
    private activatedRoute: ActivatedRoute, private profileService: ProfileService, private router: Router, private dialog: MatDialog, 
    private logger: LoggerService, private customerEnrollService: CustomerEnrollService) {
    this.sharedService.setHeaderTitle('default_page');
    this.token = this.localStorageService.get('token')
    this.is_loader = true;
    this.sharedService.setLoader('contact_info', true);
    this.activatedRoute.params.subscribe((params: Params) => {
      let acc_setting = params['account_setting'];
      this.is_acc_setting = acc_setting != undefined && acc_setting.trim() == "AccountSetting";
    });

    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };

    this.mySubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = false;
      }
    });
    if (this.token != undefined && this.token.trim() != '') {
      this.sharedService.verifyToken({ 'token': this.token })
        .then((res) => {
          this.is_loader = false;
          if (res.status === 'success') {
            this.person = res.results[0]['personal'][0];
            this.service_address = res.results[0]['service'][0];
            this.user_id = this.person['id'];
            this.email_verified = this.person.isEmailVerify === 1;
            this.email_verification_required = this.person.requiresEmailValidation;
            this.firstName = this.person['firstName'];
            this.lastName = this.person['lastName'];
            this.email = this.person['email'];
            this.mobile_no = this.person['mobilePhoneNumber'];

            // Used for dataLayer.push
            const dataLayerAccountInfo = res.results[0]['personal'];

            var dataLayerEvent = 'contact information';
            (window as any).dataLayer.push({ 'event': dataLayerEvent, 'accountID': dataLayerAccountInfo[0].id.toString(), 'accountNumber': dataLayerAccountInfo[0].accountNumber.toString() });


            const that = this.sharedService;
            setTimeout(function () {
              that.setHeaderSuccessMessage('contact_info', false, '');
              that.setHeaderErrorMessage('contact_info', false, 'notification error', '');
              that.setHeaderTitleDynamicVal('contact_info', 'Contact Information', '');

            }, 10);
            this.sharedService.setLoader('contact_info', false);
            this.sharedService.setHeaderUserLoggedIn('contact_info', true, this.person);

            if (this.email != "") {
              if (this.person['isEmailVerify'] == '1') {
                this.isEmailAddUpdate = true;
                this.isEmailVerified = true;
              } else {
                this.isEmailAddUpdate = false;
                this.isEmailVerified = false;
              }
            }

            if (this.mobile_no != "") {
              if (this.person['isOtpVerify'] == '1') {
                this.isMobileAddUpdate = true;
                this.isMobileVerified = true;
              } else {
                this.isMobileAddUpdate = false;
                this.isMobileVerified = false;
              }
            }

            if (this.email == "" || this.mobile_no == "") {
              if (this.email != "") {

                this.isContactMethodChanged = false;
                this.methods = [{ value: 'Email', viewValue: 'Email' }];
                this.preferred_contact_method = "Email";
                this.dropDisabled = true;
              }

              if (this.mobile_no != "") {
                this.isContactMethodChanged = false;
                this.methods = [{ value: 'Mobile', viewValue: 'Mobile' }];
                this.preferred_contact_method = "Mobile";
                this.dropDisabled = true;
              }
            }
            else if (this.email != "" && this.mobile_no != "") {

              this.methods = [
                { value: 'Mobile', viewValue: 'Mobile' },
                { value: 'Email', viewValue: 'Email' },
                { value: 'Both', viewValue: 'Both' }
              ];
              this.preferred_contact_method = this.person['preferedContactMethod'];

            }

            this.isContactMethodChanged = false;

            this.hasEmail = this.email != undefined && this.email.trim() != '';
            this.hasMobile = this.mobile_no != undefined && this.mobile_no.trim() != '';

            this.sharedService.setHeaderUserLoggedIn('contact_info', true, this.person);
            this.sharedService.listenLanguageCookieChange(({oldValue, newValue}) => {
              this.saveText = this.sharedService.getSaveTranslation();
            }, 1000);
          } else {
            this.localStorageService.remove('token');
            this.router.navigate(['./enroll']);
          }
        });
    } else {
      this.router.navigate(['./enroll']);
    }
  }

  updateEmailVerified(verified: boolean) {
    this.email_verified = verified;
    if (verified) {
      this.emailVerifyText = 'Verify';
      this.isWaitingEmailVerification = false;
      this.emailFormControl.enable()
    }
  }

  ngOnInit() {

  }

  ngOnChanges() {

  }
  unmaskData(data: string) {
    if (data != null && data.trim() !== '') {
      return data.replace(/[\s\(\)\-]/g, '');
    } else {
      return '';
    }
  }

  emailInputChanged(event) {
    if (this.emailFirstLoad) {
      this.initialEmail = event;
      this.emailFirstLoad = false;
    } else {
      this.emailChanged = this.initialEmail !== this.unmaskData(event.trim());
    }
  }

  mobileInputChanged(event) {
    if (this.mobileFirstLoad) {
      this.initialMobile = event;
      this.mobileFirstLoad = false;
    } else {
      this.mobileChanged = this.initialMobile !== this.unmaskData(event.trim());
    }
  }

  saveMobile() {
    this.addUpdateMobile();
  }

  saveEmail() {
    this.addUpdateEmail();
  }

  verifyEmail() {
    this.emailVerifyText = 'Verifying..';
    this.emailFormControl.disable()
    this.isWaitingEmailVerification = true;
  }

  // validation of email
  emailValidate(email: any) {
    this.isEmailError = false;
    if (this.email != null && this.email != undefined && this.email.trim() != "") {

      if (this.person['email'].trim() == this.email.trim()) {
        if (this.person['isEmailVerify'] == '1') {
          this.isEmailAddUpdate = true;
          this.isEmailVerified = true;
        } else {
          this.isEmailAddUpdate = false;
          this.isEmailVerified = false;
        }
      } else {
        this.isEmailVerified = false;
        this.isEmailAddUpdate = true;
      }

    } else {
      this.isEmailVerified = false;
      this.isEmailAddUpdate = !this.isEmailVerified && this.person['isEmailVerify'];
    }

    if (this.email != undefined && this.email.trim() != "" && this.email.match(EMAIL_REGEX)) {
      this.hasEmail = true;
    } else {
      this.hasEmail = false;
    }
  }

  // validation of mobile
  async mobileValidate(mobile: any) {
    this.isMobileError = false;
    this.is_valid_number = false;
    this.sharedService.setHeaderErrorMessage('contact_info', false, 'notification error', '');
    if (this.mobile_no != undefined && this.mobile_no.trim() != "") {
      if (this.person['mobilePhoneNumber'].trim() == this.unmaskData(this.mobile_no.trim())) {

        if (this.person['isOtpVerify'] == '1') {
          this.isMobileAddUpdate = true;
          this.isMobileVerified = true;
        } else {
          this.isMobileAddUpdate = false;
          this.isMobileVerified = false;
        }
      } else {
        this.isMobileVerified = false;
        this.isMobileAddUpdate = true;
      }
    } else {
      this.isMobileVerified = false;
      this.isMobileAddUpdate = !this.isMobileVerified && this.person['isOtpVerify'];
    }

    if (this.mobile_no != undefined && this.mobile_no.trim() != "" && !this.mobile_no.match(MOBILE_REGEX)) {
      this.hasMobile = true;
      this.mobileFormatError = true;
    } else {
      this.mobileFormatError = false;
    }
    if(this.mobile_no != undefined && this.mobile_no.match(MOBILE_REGEX)){
      
      let lookupResponse = await this.customerEnrollService.lookupPhoneNumber({phoneNumber: this.mobile_no});

      if(lookupResponse["type"] != "mobile"){
          this.sharedService.setHeaderErrorMessage('contact_info', true, 'notification error', 'The phone number provided is not capable to receiving messages.  Please consider changing to a mobile number that can receive messages.');
      }
      else{
          this.sharedService.setHeaderErrorMessage('contact_info', false, 'notification error', '');
          this.is_valid_number = true;
      }
    }
  }
  onChangeEmail() {
    this.emailFormControl.enable();
    this.isWaitingEmailVerification = false;
    this.isSavingEmail = false;
    this.emailVerifyText = 'Verify';
    this.emailSaveText = 'Save';
  }

  addUpdateEmail() {
    this.emailSaveText = 'Saving..';
    this.isSavingEmail = true;
    this.sharedService.setHeaderTitleDynamicVal('contact_info', 'Contact Information', '');
    this.sharedService.setHeaderErrorMessage('contact_info', false, 'notification error', '');
    this.sharedService.setHeaderSuccessMessage('contact_info', false, 'Your OTP has been successfully sent.');
    let methodName = this.constructor.name + '.updateEmail';
    this.profileService.updateEmail({ 'token': this.localStorageService.get('token'), 'email': this.email })
      .then(res => {
        let logObj = {
          method: methodName,
          request: "token : [masked], email : " + this.email,
          response: res
        };
        this.logger.logInfo(JSON.stringify(logObj));
        this.sharedService.setHeaderTitleDynamicVal('contact_info', 'Contact Information', '');
        if (res.status === 'success') {
          this.emailFormControl.disable()
          this.initialEmail = this.email;
          this.isWaitingEmailVerification = true;
          this.isSavingEmail = false;
          this.emailChanged = false;
          this.email_verified = false;
        } else {
          this.isEmailError = true;
          this.emailError = res.message;
          this.emailSaveText = 'Save';
          this.isSavingEmail = false;
          this.isWaitingEmailVerification = false;
        }
      }, (error) => {
        let logObj = {
          method: methodName,
          request: "token : [masked], email : " + this.email,
          exception: error
        };
        this.logger.logError(JSON.stringify(logObj));
        this.emailSaveText = 'Save';
        this.isSavingEmail = false;
        this.isWaitingEmailVerification = false;
      }).catch((ex) => {
      let logObj = {
        method: methodName,
        request: "token : [masked], email : " + this.email,
        exception: ex
      };
      this.logger.logError(JSON.stringify(logObj));
      this.emailSaveText = 'Save';
      this.isSavingEmail = false;
      this.isWaitingEmailVerification = false;
    });
  }

  addUpdateMobile() {
    this.is_loader = true;
    this.sharedService.setLoader('contact_info', true);
    this.sharedService.setHeaderTitleDynamicVal('contact_info', 'Contact Information', '');
    this.sharedService.setHeaderErrorMessage('contact_info', false, 'notification error', '');
    this.sharedService.setHeaderSuccessMessage('contact_info', false, 'Your OTP has been successfully sent.');
    let methodName = this.constructor.name + '.updateMobile';
    this.profileService.updateMobile({ 'token': this.localStorageService.get('token'), 'mobile': this.unmaskData(this.mobile_no) })
      .then(res => {
        let logObj = {
          method: methodName,
          request: "token : [masked], mobile: " + this.unmaskData(this.mobile_no),
          response: res
        };
        this.logger.logInfo(JSON.stringify(logObj));
        this.is_loader = false;
        this.sharedService.setLoader('contact_info', false);
        this.sharedService.setHeaderTitleDynamicVal('contact_info', 'Contact Information', '');
        if (res.status === 'success') {
          this.dialog.open(UpdateContact, {
            data: {
              message: res.message,
              raw_id: this.user_id,
              is_acc_setting: this.is_acc_setting,
              for_what: "mobile"
            }
          });

        } else {
          this.isMobileError = true;
          this.mobileError = res.message;

        }
      }, (error) => {
        let logObj = {
          method: methodName,
          request: "token : [masked], mobile: " + this.unmaskData(this.mobile_no),
          exception: error
        };
        this.logger.logError(JSON.stringify(logObj));
      }).catch((ex) => {
      let logObj = {
        method: methodName,
        request: "token : [masked], mobile: " + this.unmaskData(this.mobile_no),
        exception: ex
      };
      this.logger.logError(JSON.stringify(logObj));
    });
  }

  contactMethodValidate(contactMethod) {
    this.isContactMethodChanged = this.preferred_contact_method.trim() != this.person['preferedContactMethod'].trim();
  }

  contactMethodSave() {
    this.is_loader = true;
    this.sharedService.setLoader('contact_info', true);
    this.sharedService.setHeaderTitleDynamicVal('contact_info', 'Contact Information', '');
    let notification_channel_setting = {
      'token': this.localStorageService.get('token'),
      'preferredContactMethod': this.preferred_contact_method
    };
    let methodName = this.constructor.name + '.updateNotificationChannel';
    this.profileService.updateNotificationChannel(notification_channel_setting).then(res => {
      let logObj = {
        method: methodName,
        request: notification_channel_setting,
        response: res
      };
      this.logger.logInfo(JSON.stringify(logObj));
      window.scrollTo(0, 0);
      this.is_loader = false;
      this.sharedService.setLoader('contact_info', false);
      this.sharedService.setHeaderTitleDynamicVal('contact_info', 'Contact Information', '');
      if (res.status === 'success') {
        this.sharedService.setHeaderSuccessMessage('contact_info', true, "Preferred Contact Method Updated Successfully.");
        const this_obj = this;
        this.person['preferedContactMethod'] = this.preferred_contact_method;
        this.isContactMethodChanged = false;
        setTimeout(function () {
          this_obj.sharedService.setHeaderSuccessMessage('contact_info', false, '');
        }, 5000);
      } else {
        if (res.type === 'timeup') {
          this.router.navigate(['./Profile/AccountSetting/SignIn']);
        } else {
          this.sharedService.setHeaderErrorMessage('contact_info', true, 'notification error', res.message);
        }
      }
    }, (error) => {
      let logObj = {
        method: methodName,
        request: notification_channel_setting,
        exception: error
      };
      this.logger.logError(JSON.stringify(logObj));
    }).catch((ex) => {
      let logObj = {
        method: methodName,
        request: notification_channel_setting,
        exception: ex
      };
      this.logger.logError(JSON.stringify(logObj));
    });
  }

}

@Component({
  selector: 'update-email-address',
  template: `<div class="dialog-main"><h3 class="text-center">Info</h3><p>{{message}}</p></div><div class="footer" style=" display: flex;"><button mat-button class="double-block-btn border-b-none dialog-btn-border-r" [mat-dialog-close]="true" (click)="ok()">Okay</button></div>`,
})
export class UpdateContact {
  public message: any;
  public user_id: string;
  public for_what: string;
  public is_acc_setting: boolean;
  public is_verify_request: boolean;
  constructor(private activatedRoute: ActivatedRoute, private dialog: MatDialog, private sharedService: SharedService, private localStorageService: LocalStorageService, private router: Router, public dialogRef: MatDialogRef<UpdateContact>, @Inject(MAT_DIALOG_DATA) public data: any, private logger: LoggerService) {
    this.message = this.data.message;
    this.user_id = this.data.raw_id;
    this.is_acc_setting = this.data.is_acc_setting;
    this.for_what = this.data.for_what;
    this.is_verify_request = this.data.is_verify_request;
  }



  ok() {
    if (this.is_verify_request) {
      if (this.for_what.trim() == 'email') {
        if (this.is_acc_setting) {
          this.router.navigate(['./email/verify/AccountSetting/' + this.user_id]);
        } else {
          this.router.navigate(['./email/verify/' + this.user_id]);
        }
      } else {
        if (this.is_acc_setting) {
          this.router.navigate(['./Profile/AccountSetting/ChangePhoneNumber/' + this.user_id + '/OtpVerify']);
        } else {
          this.router.navigate(['./otp-verify/' + this.user_id]);
        }
      }
    }else{
      this.router.navigate(['/contact-info/AccountSetting']);
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/profile/contact-info/contact-info.component.ts